// extracted by mini-css-extract-plugin
export default {"editorWrapper":"emailTemplateDtls_editorWrapper__6ovYy"};